import React, { Fragment } from 'react';
import { useFormik } from 'formik';
import Button from '../Button';

const validate = values => {
  const errors = {};
  if (!values.existingDomain) {
    errors.existingDomain = 'Required';
  }
  if (!values.apiKey && values.existingDomain === 'Other') {
    errors.apiKey = 'Required';
  }
  if (!values.domain && values.existingDomain === 'Other') {
    errors.domain = 'Required';
  }
  return errors;
};

const FLGForm = ({ fields, onSubmit, existingDomains }) => {
  const formik = useFormik({
    initialValues: {
      existingDomain: existingDomains ? existingDomains[0] : 'Other',
      apiKey: '',
      domain: ''
    },
    validate,
    onSubmit: values => {
      let form = {};
      if(values.existingDomain === 'Other'){
        form.apiKey = values.apiKey;
        form.domain = values.domain;
      } else {
        form.domain = values.existingDomain
      }
      onSubmit(form)
    }
  });
  return (
    <form onSubmit={formik.handleSubmit} className='form'>
      <div className="input-field">
        <label htmlFor='existingDomain'>Existing Domain</label>
        <select
          id='existingDomain'
          name='existingDomain'
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.existingDomain}>
          {existingDomains ? existingDomains.concat('Other').map((option,i) => <option key={i}>{option}</option>) : <option>Other</option>}
        </select>
        {formik.touched.existingDomain && formik.errors.existingDomain ? <div className="cl-error">{formik.errors.existingDomain}</div> : null}
      </div>
      {formik.values.existingDomain === 'Other' ?
        <Fragment>
          <div className={`input-field ${formik.touched.apiKey && formik.errors.apiKey ? 'error' : ''}`}>
            <label htmlFor='apiKey'>API Key</label>
            <input 
              id='apiKey' 
              name='apiKey' 
              type='text' 
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.apiKey}
              placeholder='Please enter your API key'/>
            {formik.touched.apiKey && formik.errors.apiKey ? <div className="cl-error">{formik.errors.apiKey}</div> : null}
            {fields.template.apiKey.installHelp ? <a href={fields.template.apiKey.installHelp.url} target='_blank' className="cl-help">{fields.template.apiKey.installHelp.text}</a> : null}
          </div>
          <div className={`input-field ${formik.touched.domain && formik.errors.domain ? 'error' : ''}`}>
            <label htmlFor='domain'>Domain</label>
            <input 
              id='domain' 
              name='domain' 
              type='text' 
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.domain}
              placeholder='Please enter your API key'/>
            {formik.touched.domain && formik.errors.domain ? <div className="cl-error">{formik.errors.domain}</div> : null}
            {fields.template.domain.installHelp ? <a href={fields.template.domain.installHelp.url} target='_blank' className="cl-help">{fields.template.domain.installHelp.text}</a> : null}
          </div>
        </Fragment>
      : null}
      <div className="buttons">
        <Button styling="apps-outlined" type="submit">Apply</Button>
      </div>
    </form>
  );
};

export default FLGForm;


// WEBPACK FOOTER //
// ./src/components/CLForm/FLGForm.js